<template>
    <div class="d-flex justify-content-between pt-3 styleInIPad">
        <div>
            <div class="mb-3">
                <router-link class="back-route h3" ref="backBtn" @click="backHandler" :to="isFull ? '#':'/trainings'">
                    <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                    {{training.name}}
                </router-link>
            </div>
            <div class="mx-3">
                <p>{{templateName}} &nbsp;&nbsp

                    <router-link :to="'/templates/view/'+template_id_view" v-if="permissions.includes('viewAny template')" class="linkViewTemplate">
                        View Template
                    </router-link>
                </p>
            </div>
        </div>
        <div class="btnOrganization ">
<!--            <button @click.prevent="SaveTraining">-->
<!--                Save Training-->
<!--            </button>-->
        </div>
    </div>

    <div id="createUserContainer" class="tabcontent1">
        <div class="firstStartDate" v-if="training.start_date != null">
            <h4>Start Date</h4>
            <h6>{{training.start_date}}</h6>
        </div>
        <div class="firstStartDate" v-else>
            <h4>Start Date</h4>
            <h6>Not Choosen</h6>
        </div>

        <div class="secondEndDate" v-if="training.end_date != null">
            <h4>End Date</h4>
            <h6>{{training.end_date}}</h6>
        </div>
        <div class="secondEndDate" v-else>
            <h4>End Date</h4>
            <h6>Not Choosen</h6>
        </div>

        <div class="startTimeCss" v-if="training.start_time != null">
            <h4>Start Time</h4>
            <h6>{{training.start_time}} GMT</h6>
        </div>
        <div class="startTimeCss" v-else>
            <h4>Start Time</h4>
            <h6>Not Choosen</h6>
        </div>

        <div class="startTimeCss" v-if="training.end_time != null">
            <h4>End Time</h4>
            <h6>{{training.end_time}} GMT</h6>
        </div>
        <div class="startTimeCss" v-else>
            <h4>End Time</h4>
            <h6>Not Choosen</h6>
        </div>

        <div class="durationCss" v-if="training.duration != null">
            <h4>Duration</h4>
            <h6>{{training.duration}} minutes</h6>
        </div>
        <div class="durationCss" v-else>
            <h4>Duration</h4>
            <h6>{{durationInTime}} minutes</h6>
        </div>

        <div class="cssActionsStyle">
<!--            <font-awesome-icon  :icon="['fas', 'trash']" class="trashDesign" v-if="permissions.includes('delete training')" @click.prevent="deleteTraining"  size="xl"/>-->
            &nbsp;&nbsp;&nbsp;&nbsp;
<!--            <font-awesome-icon :icon="['fas', 'pen']" class="penDesign" size="xl" @click.prevent="EditTraining"/>-->
        </div>
    </div>

    <div v-if="training_type === 'private'">
        <div  v-if="usersAssignedData.length > 0" class="row w-100">
            <div class="d-flex justify-content-between mb-4">
                <div>
                    <!--                <h3>Users</h3>-->
                </div>
                <div class="btnOrganization2">
                    <button @click.prevent="AssignUserToTraining">Assign</button>
                </div>
            </div>

            <div class="row d-flex styleFlex">
                <div class="col-md-2 styleCssAssigned" v-for="user in usersAssignedData" :key="user.id">
                    <div class="styleUser">
                        {{user.participant.name}}
                    </div>
                    <div class="styleTrash">
                        <font-awesome-icon  :icon="['fas', 'trash']" class="trash" @click.prevent="deleteUser(user.id)"  size="lg"/>
                    </div>
                </div>
            </div>
        </div>

        <div id="createUserContainer2" class="d-flex justify-content-center" v-else>
            <div class="assignUsersCss">
                <div class="text-center mb-4">
                    <img src="../../../assets/images/surface1.svg" alt="" >
                </div>
                <div class="text-center mb-4">
                    <h5>No Users or Teams Are Assigned for This Trainings</h5>
                </div>
                <div class="buttonCssAssign text-center">
                    <button @click="AssignUserToTraining">Assign</button>
                </div>
            </div>
        </div>
    </div>

    <div v-else></div>

    <AssignUsers @clickAssign="clickAssignHandler" v-if="this.isShow" :whoPlay="whoPlay" :participant="participant_type_data" :training_type="training_type" :message="confirmMessage" :confirmUsers="ChooseUsers" :confirmTeam="ChooseTeam"
                 @close-modal="this.isShow = false"
                 :confirmTeamLeader="ChooseTeamLeader"/>

    <ModalChooseUser @close-modal="closeModalHandler" v-if="this.isAssignFlag" :whoPlay="whoPlay" :participant="participant_type_data" :training_type="training_type" :message="chooseMessageText" :data="data" @assignUsers1="AssignUsers1" @assignUsers2="AssignUsers2"/>

    <AssignTeamLeader v-if="isShow2" @close-modal="closeModalTraining"  @success="ShowModalSuccess" :whoPlay="whoPlay" :message="confirmMessage" :participant="participant_type_data" :training_type="training_type" :confirmUsers="ChooseUsers" :confirmTeam="ChooseTeam" />

    <ConfirmationModal v-if="confirmModalFlag2" :message="confirmMessage" confirmBtn="Delete" cancleBtn="Cancel"
                       @close-modal="confirmModalHandler($event)"/>

    <ConfirmationModal v-if="confirmModalFlag3" :message="confirmMessage2" :id="training_user_id" confirmBtn="Delete" cancleBtn="Cancel"
                       @close-modal="confirmModalHandler2($event)"/>

    <AlartModal v-if="showModal" :message="message" :imagePath="ImagePath" @close-modal="showModal = false"/>
</template>

<script>
    import AssignUsers from '../../components/AssignUsers';
    import AssignTeamLeader from '../../components/AssignTeamLeader';
    import ModalChooseUser from '../../components/ModalChooseUsers';
    import training from "../../../api-services/training";
    import ConfirmationModal from "../../components/ConfirmationModal";
    import AlartModal from "../../components/AlartModal";
    import {computed} from "vue";
    import moment from "moment";
    import competition from "../../../api-services/competition";

    export default {
        name:'complete-edit-training',
        props:['ChooseUsers' , 'ChooseTeam' , 'ChooseTeamLeader' , 'AssignUsers' , 'success'],
        data(){
            return {
                isFull:false,
                isShow:false,
                isShow2:false,
                permissions:[],
                showModal:false,
                message:'',
                ImagePath:'',
                isAssignFlag: false,
                confirmModalFlag: false,
                confirmModalFlag2: false,
                confirmModalFlag3: false,
                training_user_id:null,
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData:{

                },
                training:{
                    name:null,
                    template_id:null,
                    type:2,
                    start_date:null,
                    end_date:null,
                    start_time:null,
                    end_time:null,
                    duration:null
                },
                data: [],
                usersAssignedData:[],
                templateName:'',
                durationInTime:null,
                template_id_view:null,
                confirmMessage: '',
                confirmMessage2: '',
                chooseMessageText:'',
                training_type:null,
                participant_type_data:null,
                whoPlay:null
            }
        },
        components:{
            AssignUsers,
            ModalChooseUser,
            ConfirmationModal,
            AssignTeamLeader,
            AlartModal
        },
        async mounted(){
            this.getTraining();
            this.getUsersAssigned();
            this.permissions = this.$store.state.auth.permissions;
            const compData = await training.show(this.$route.params.id);
            this.training_type = compData.data.data.training_type;
            this.whoPlay = compData.data.data.is_play;
        },
        methods:{
            ShowModalSuccess(){
                const training_id = this.$route.params.id;
                this.isShow2 = false;
                this.showModal = true;
                this.ImagePath = 'okImage.svg';
                this.message = "Users Assigned Successfully";
                window.location.href="/complete-edit-trainings/"+training_id;
            },
            clickAssignHandler(event){
                this.isAssignFlag = true;
                this.data = event[1].data.data;
                this.chooseMessageText = event[0];
            },
            AssignUsers1(){
                const training_id = this.$route.params.id;
                this.isAssignFlag = false;
                this.isShow = false;
                this.showModal = true;
                this.ImagePath = 'okImage.svg';
                this.message = "Users Assigned Successfully";
                window.location.href = "/complete-edit-trainings/"+training_id;
            },

            AssignUsers2(){
                const training_id = this.$route.params.id;
                this.isAssignFlag = false;
                this.isShow = false;
                this.isShow2 = true;
            },

            closeModalHandler(e){
                this.isShow = false;
                this.isAssignFlag = false
            },

            async backHandler () {
                let setDataFlag = this.$store.state.settings.setDataFlag;
                if(setDataFlag){
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                }else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false
                }
            },
            async confirmModalHandler (event) {
                // await this.$store.dispatch('setConfirmModal', false);
                this.confirmModalFlag2 = false;
                if(event){
                    const training_id = this.$route.params.id;
                    await competition.delete(training_id);
                    // await this.$store.dispatch('setDataFlag', false);
                    this.confirmModalFlag2 = false;
                    await this.$router.push('/trainings');
                }
            },
            async confirmModalHandler2 (event) {
                this.confirmModalFlag3 = false;
                if(event){
                    const training_id = this.$route.params.id;
                    await training.deleteUserAssigned(this.training_user_id);

                    this.confirmModalFlag3 = false;
                    // await this.$router.push('/complete-edit-competitions/'+competition_id);
                    window.location.href = '/complete-edit-trainings/'+training_id;
                }
            },
            AssignUserToTraining(){
                this.isShow = true;
                this.confirmModalFlag = true;
                this.confirmMessage = 'Assign to';
            },
            async closeModalTraining(){
                const competition_id = this.$route.params.id;
                await competition.deleteCompetitionUsers(competition_id);
                this.isShow2 = false;
            },
            async getTraining(){
                const training_id = this.$route.params.id;
                try{
                    const response = await training.show(training_id);
                    if (process.env.VUE_ENV === 'development')
                    console.log(response);

                    this.training.name = response.data.data.name.charAt(0).toUpperCase() +  response.data.data.name.slice(1);
                    this.training.template_id = response.data.data.template_id;
                    this.training.start_date = moment(response.data.data.start_date).format('D-MMM-YYYY');
                    this.training.end_date = moment(response.data.data.end_date).format('D-MMM-YYYY');
                    this.training.start_time = response.data.data.start_time.slice(0,5);
                    this.training.end_time = response.data.data.end_time.slice(0,5);
                    this.training.duration = response.data.data.duration;
                    this.templateName = response.data.data.template.name;

                    if(this.training.duration === null){
                        let startTime = moment(this.training.start_time, "HH:mm:ss a");
                        let endTime = moment(this.training.end_time, "HH:mm:ss a");
                        let duration  = moment.duration(endTime.diff(startTime));
                        let hours = parseInt(duration.asHours()) * 60;
                        let minutes = parseInt(duration.asMinutes()) % 60;

                        this.durationInTime = (hours+minutes);
                    }

                    this.template_id_view = response.data.data.template.id;
                }catch(e) {
                    if (process.env.VUE_ENV === 'development')
                    console.log(e);
                }
            },
            async getUsersAssigned(){
                const training_id = this.$route.params.id;
                try{
                    const response = await training.getUsersAssigned(training_id);
                    if (process.env.VUE_ENV === 'development')
                    console.log(response.data.data);
                    this.usersAssignedData = response.data.data;
                }catch(e){
                    if (process.env.VUE_ENV === 'development')
                    console.log(e);
                }
            },
            deleteTraining(){
                this.confirmModalFlag2 = true;
                this.confirmMessage = 'Do you want to delete this competition?';
            },
            EditTraining(){
                const competition_id = this.$route.params.id;
                this.$router.push({path: "/edit-trainings/"+competition_id});
            },
            deleteUser(e){
                try{
                    this.training_user_id = e;
                    this.confirmModalFlag3 = true;
                    this.confirmMessage2 = 'Do you want to delete this user?';
                }catch(error){
                    if (process.env.VUE_ENV === 'development')
                    console.log(error);
                }
            },
            async SaveTraining(){
                try{
                    const training_id = this.$route.params.id;

                    if(this.training.start_time === null && this.training.end_time === null){
                        this.training.date_type = 2;
                    }else{
                        this.training.date_type = 1;
                    }
                    await training.update(training_id , {
                        name:this.training.name,
                        template_id:this.template_id_view,
                        type:2,
                        date_type:this.training.date_type,
                        start_date:this.training.start_date,
                        end_date:this.training.end_date,
                        start_time:this.training.start_time,
                        end_time:this.training.end_time,
                        duration:this.training.duration,
                    });
                    await this.$store.dispatch('setDataFlag', false);

                    this.$router.push({path: "/trainings"});
                }catch(e){
                    if (process.env.VUE_ENV === 'development')
                    console.log(e);
                }
            }
        }
    }
</script>

<style scoped>
    .styleInIPad{
        margin-bottom: 0px;
    }
    .styleTrash{
        position:absolute;
    }
    .trash{
        position: relative;
        top:12px;
        left: 260px;
        color: #FF7171;
        cursor: pointer;
    }
    .styleUser{
        display: flex;
        align-items: center;
        padding-left: 10px;
    }
    .styleFlex{
        gap:50px;
        padding-left: 24px;
    }
    .styleCssAssigned{
        display: flex;
        border: 1px solid #39525C;
        width: 300px;
        height: 50px;
        border-radius: 6px;
    }
    .btnOrganization2 button {
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
        border: none;
        border-radius: 5px;
        justify-content: end;
        /*align-content: center;*/
        width: 140px;
        padding: 10px;
    }

    .btnOrganization button {
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
        border: none;
        border-radius: 5px;
        justify-content: end;
        align-content: center;
        padding: 10px;
    }

    .buttonCssAssign button{
        border:none;
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
        padding: 10px 70px;
        border-radius: 5px;
    }
    .penDesign {
        color: #00970A;
        cursor: pointer;
    }
    .trashDesign {
        color: #FF7171;
        cursor: pointer;
    }
    .cssActionsStyle{
        width: 370px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .firstStartDate{
        width:370px;
    }
    .secondEndDate{
        width:370px;
    }
    .startTimeCss{
        width:370px;
    }
    .durationCss{
        width:370px;
    }
    .linkViewTemplate{
        color:#e65c00;
    }
    .assignUsersCss{
        width:700px;
        padding: 30px;
        height: 25vh;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 15px;
    }
    .tabcontent1{
        display: flex;
        padding: 30px;
        height: 15vh;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 15px;
        margin-bottom: 5rem;
    }

    @media only screen and (max-width: 1300px) and (min-width: 1250px) {
        .styleInIPad{
            margin-bottom: 0px;
        }
        .tabcontent1{
            height: 21vh;
            margin-bottom: 2rem;
        }
        .assignUsersCss{
            height: 33%;
        }
    }
</style>